// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileExcelTwoToneSvg from "@fishx/icons-svg/es/asn/FileExcelTwoTone";
import FishxIcon from '../components/FishxIcon';

var FileExcelTwoTone = function FileExcelTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileExcelTwoToneSvg
  }));
};

FileExcelTwoTone.displayName = 'FileExcelTwoTone';
export default React.forwardRef(FileExcelTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileExcelTwoTone.js
// module id = 2691
// module chunks = 0